import styled from 'styled-components';
import { CardActions } from '@one-thd/sui-atomic-components';

export const ResponsiveCardActions = styled(CardActions)`
  padding: 1.6rem 0;
  @media (max-width: 639px) {
    padding: 0;
  }
`;

export const AddMobileSpacing = styled.div`
  padding-bottom: 0;
  @media (max-width: 639px) {
    padding-bottom: 1.6rem;
  }
`;